<!-- original -->
<div *ngIf="!reverse" class="progress-outer" [style.backgroundColor]="'#f4f4f4'">
  <div class="progress-inner" [style.backgroundColor]="backColor" [style.width]="progress + '%'"
    [style.height]="height + 'px'">
  </div>
</div>

<!-- reverse  -->
<div *ngIf="reverse" class="progress-outer" [style.backgroundColor]="backColor">
  <div class="progress-inner" [style.backgroundColor]="'#ffffff'" [style.width]="progress + '%'"
    [style.height]="height + 'px'">
  </div>
</div>